
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';
import moment from 'moment';
import itemMixin from '@/minix/itemMixin';

const { report } = api;

@Component({ components: { DateRange } })
export default class SuperPointGenerateReport extends Mixins(Vue.extend(itemMixin)) {
  private data = {
    data: [],
    totalPoints: 0,
    totalCount: 0,
    pageSize: 20,
    pageNo: 0,
  };

  private panel = 0;

  private loading = false;

  private sourceTypes: Array<{ text: string; value: string }> = [
    { text: '推薦代碼', value: '1' },
    { text: '受邀贈點', value: '2' },
    { text: '邀請好友', value: '3' },
    { text: '行銷活動贈點', value: '4' },
    { text: '兌換商品回饋(含行動支付)', value: '5' },
    { text: '後台手動贈點', value: '6' },
  ];

  private headers = [
    { text: '交易時間', value: 'createDate', width: 40 },
    { text: 'SP點數量', value: 'pointValue', width: 40 },
    { text: '來源', value: 'source', width: 160 },
    { text: '備註', value: 'remark', width: 160 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get totalPoints() {
    return this.data.totalPoints;
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    source: this.$route.query.source || undefined,
    remark: this.$route.query.remark || undefined,
    startDate:
      this.$route.query.startDate === undefined
        ? this.getToday()
        : this.$route.query.startDate,
    endDate: this.$route.query.endDate || undefined,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private getToday() {
    return moment().format('yyyy-MM-DD');
  }

  private async updatePage(page: number) {
    await this.query(page);
  }

  private async query(page: number) {
    this.pager.pageNo = typeof page === 'number' ? page : 1;
    const query = {
      ...this.filter,
      pageSize: `${this.pager.pageSize}`,
      pageNo: `${this.pager.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      source: undefined,
      remark: undefined,
      startDate: this.getToday(),
      endDate: undefined,
    };
    await this.query(1);
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const filter = { ...this.filter };
    const { status, data } = await report.exportSuperPointGenerate(filter);
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, 'SP點數產出紀錄.txt');
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.filter, ...this.pager };
    const { status, data } = await report.listSuperPointGenerate(filter);
    this.loading = false;
    if (status === 1) {
      this.data = data;
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: SuperPointGenerateReport) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
